import { createBrowserHistory } from 'history';

export const history = typeof document === 'undefined' ? null : createBrowserHistory();
